export const getExpiredDateFromToday = day => {
  const today = new Date();
  const expiredDayFromToday = new Date();
  expiredDayFromToday.setDate(today.getDate() + day);

  return expiredDayFromToday;
};



// WEBPACK FOOTER //
// ./helpers/expiredDate.helper.js